import { render, staticRenderFns } from "./OCard.vue?vue&type=template&id=7800672f&scoped=true&"
import script from "./OCard.vue?vue&type=script&lang=js&"
export * from "./OCard.vue?vue&type=script&lang=js&"
import style0 from "./OCard.vue?vue&type=style&index=0&id=7800672f&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7800672f",
  null
  
)

export default component.exports